import { BACKEND } from "@/lib/api";

export const anlopCode = (key, attr) => `<div class="havnekalkulator" data-${attr}="${key}"></div>\n<script src="${BACKEND}/api/embed/loader.js" async></script>`;

export const hq = (pid) => (pid && pid !== "main" ? `?h=${encodeURIComponent(pid)}` : "");
